import PropTypes from 'prop-types';

export default {
  breakpoint: PropTypes.object.isRequired,
  handleExitModify: PropTypes.func.isRequired,
};
